import React from 'react';
import { Box, makeStyles, Theme, createStyles } from '@material-ui/core';
import ArrowChevronLeft from '@jda/lui-common-icon-library/ui/ArrowChevronLeft';
import { useParams, useHistory } from 'react-router-dom';
import ProviderHeader from './ProviderHeader';
import ProviderTabs from './ProviderTabs';
import ProviderServiceTabs from './ProviderServiceTabs';
import client from '../../utils/eventEmit';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1
    },
    icon: {
      color: theme.palette.background.paper,
      cursor: 'pointer'
    },
    header: {
      color: theme.palette.background.paper,
      fontSize: '26px'
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary
    }
  })
);

const Provider = (props: any) => {
  const classes = useStyles();
  let { code, workflowCode } = useParams();
  let enable = false;
  if (workflowCode) {
    enable = true;
  }
  const [enableDetail, setEnableDetail] = React.useState(enable);
  let history = useHistory();

  const [serviceCode, setServiceCode] = React.useState(workflowCode);
  const setEmittedCode = (data: any) => {
    setServiceCode(data[0]);
    setEnableDetail(true);
  };
  client.on('serviceCodeKey', setEmittedCode);

  const handleClick = () => {
    history.push(`/${window.location.pathname.split('/')[1]}`);
  };
  return (
    <Box px={2} overflow="hidden" width="100%">
      {(props.userRole !== 'PARTICIPANT_SUPPORT' || props.userRole !== 'PARTICIPANT_ADMIN') && (
        <>
          <Box px={1} pt={2} display="flex" alignItems="flex-end">
            <Box>
              <ArrowChevronLeft onClick={handleClick} className={classes.icon} />
            </Box>
            <Box pl={1} className={classes.header}>
              {code}
            </Box>
          </Box>
        </>
      )}
      <Box p={1}>
        <ProviderHeader data={props.data} />
      </Box>
      <Box p={1}>
        <ProviderTabs
          data={props.data}
          enableDetail={setEnableDetail}
          workflowCode={serviceCode}
          participantCode={props.participantCode}
        />
      </Box>
      {serviceCode && enableDetail && (
        <Box p={1}>
          <ProviderServiceTabs workflowCode={serviceCode} participant={props.data} />
        </Box>
      )}
    </Box>
  );
};

export default Provider;
